import React, { useEffect, useState } from "react";
import CuerpoPrincipal from "../elementos/basicos/CuerpoPrincipal";
import ContenedorPrincipal from "../elementos/basicos/ContenedorPrincipal";
import FormCrearCurso from "../elementos/complejos/FormCrearCurso";
import FormEditarCurso from "../elementos/complejos/FormEditarCurso";
import { fetchSubcategorias, fechtOptenerModelos } from '../../peticiones_API/PeticionesCursoConvocatoria';
import Navbar from "../elementos/cuerpo/Navbar";
const GestorCurso = ({ crear }) => {


  const [proveedores, setProveedores] = useState();
  const [categorias, setcategorias] = useState();
  const [subcategorias, setSubcategorias] = useState([]);
  const [requisitos, setRequisitos] = useState();
  const [loading, setLoading] = useState(true);
  const [categoriaSelect, setCategoriaSelect] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (categoriaSelect == null) {
          const listadoResponse = await fechtOptenerModelos(["Requisito", "Proveedores", "Categoria"], true);
          console.log("listadoResponse", listadoResponse);

          setcategorias(listadoResponse.Categoria);
          setProveedores(listadoResponse.Proveedores);
          setRequisitos(listadoResponse.Requisito);
        }


        setLoading(false);
      } catch (error) {
        console.log("Ha habido un error:", error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);


  useEffect(() => {
    const fetchData = async () => {
      try {

        if (categoriaSelect != null) {
          const subcategoriasResponse = await fetchSubcategorias(categoriaSelect);
          setSubcategorias(subcategoriasResponse[0].SubCategoria);
          console.log("subcategoriasResponse", subcategoriasResponse[0].SubCategoria);
        }

      } catch (error) {
        console.log("Ha habido un error:", error);
        setLoading(false);
      }
    };

    fetchData();
  }, [categoriaSelect]);

  if (loading) {
    return <div>Cargando...</div>;
  }
  return (
    <>
        <ContenedorPrincipal formaform="true"  >

          {crear ?
            <FormCrearCurso
              proveedores={proveedores}
              categorias={categorias}
              requisitos={requisitos}
              categoriaSelect={categoriaSelect}
              setCategoriaSelect={setCategoriaSelect}
              subcategorias={subcategorias}
            />
            :
            <FormEditarCurso
              proveedores={proveedores}
              categorias={categorias}
              requisitos={requisitos}
              categoriaSelect={categoriaSelect}
              setCategoriaSelect={setCategoriaSelect}
              subcategorias={subcategorias}
            />
          }


        </ContenedorPrincipal>

    </>
  );
}

export default GestorCurso;